"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _bowser = _interopRequireDefault(require("bowser"));

var _uuid = _interopRequireDefault(require("../uuid"));

var _composedLog = _interopRequireDefault(require("./composed-log.js"));

var _asyncMetric = _interopRequireDefault(require("./async-metric.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var logSession = (0, _uuid["default"])();

var Logger = /*#__PURE__*/function () {
  function Logger(name, additionalLogData, batch, env) {
    _classCallCheck(this, Logger);

    this.fetch = env.fetch;
    this.composed = undefined;
    this.batchSize = batch.size;
    this.batchUnit = batch.unit || 'log';
    this.composed = this.batchSize ? (0, _composedLog["default"])(additionalLogData) : undefined;
    this.name = name;
    this.additionalLogData = additionalLogData;
    this.performanceApi = env.performance;
    this.beaconApi = env.beacon;
    this.bowser = _bowser["default"].getParser(env.userAgent);
    if (!this.additionalLogData.logSession) this.additionalLogData.logSession = logSession;
    this.commonFields = {
      os: this.bowser.getOSName(),
      osVersion: this.bowser.getOSVersion(),
      browser: this.bowser.getBrowserName(),
      browserVersion: this.bowser.getBrowserVersion(),
      device: this.bowser.getPlatformType(),
      engineName: this.bowser.getEngineName()
    };
    this.resource = this.additionalLogData.resource || '/application/log.gif';
  }

  _createClass(Logger, [{
    key: "debug",
    value: function debug(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._log('DEBUG', true, message, fields, Date.now());
    }
  }, {
    key: "info",
    value: function info(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._log('INFO', true, message, fields, Date.now());
    }
  }, {
    key: "warn",
    value: function warn(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._log('WARN', true, message, fields, Date.now());
    }
  }, {
    key: "error",
    value: function error(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._log('ERROR', false, message, fields, Date.now());
    }
  }, {
    key: "metric",
    value: function metric(message) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this._log('METRIC', true, message, _objectSpread({}, fields, {
        duration: duration
      }), Date.now());
    }
  }, {
    key: "asyncMetric",
    value: function asyncMetric(message, url) {
      return new _asyncMetric["default"](this, message, url, this.performanceApi);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.composed) return null;
      this.composed = (0, _composedLog["default"])(this.additionalLogData);
    }
  }, {
    key: "resume",
    value: function resume() {
      if (!this.composed) return;
      var payload = this.composed.serialize();
      this.composed = undefined;
      var data = {
        name: this.name,
        level: 'BATCH',
        payload: payload
      };

      this._logData(data);

      if (this.batchSize) this.pause();
    }
  }, {
    key: "_log",
    value: function _log(level, success, message, fields, timestamp) {
      var data = _objectSpread({}, {
        name: this.name,
        level: level,
        message: message,
        success: success,
        msg: message,
        timestamp: timestamp
      }, this.commonFields, this.additionalLogData, fields);

      data = this._cleanupData(data);

      if (this.composed) {
        this.composed.add(message, data);

        if (this.batchSize && this.composed.size() >= this.batchSize) {
          this.resume();
        }

        return;
      }

      this._logData(data);
    }
  }, {
    key: "_logData",
    value: function _logData(data) {
      var components = Object.keys(data).map(function (key) {
        var value = data[key];
        if (!value && value !== 0 || typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return '';
        return "".concat(key, "=").concat(encodeURIComponent(value));
      });

      this._request(components.join('&'));
    }
  }, {
    key: "_cleanupData",
    value: function _cleanupData(data) {
      var output = {};

      for (var key in data) {
        if (!data.hasOwnProperty(key)) continue;
        var value = data[key];
        var derivedValue = typeof value === 'function' ? value() : value;

        if (derivedValue != null) {
          output[key] = "".concat(derivedValue).substring(0, 1000);
        }
      }

      return output;
    }
  }, {
    key: "_request",
    value: function _request(queryParams) {
      var url = "".concat(this.resource, "?").concat(queryParams);

      if (this.beaconApi) {
        this.beaconApi.sendBeacon(url);
        return;
      }

      this.fetch(url)["catch"](function (error) {
        return console.error("Unable to log message: ".concat(url, ", received ").concat(error));
      });
    }
  }]);

  return Logger;
}();

;

function fetchRequest(url) {
  if (typeof window === 'undefined') {
    return Promise.reject('Not available during SSR');
  }

  if (typeof window.fetch === 'function') {
    return window.fetch(url);
  }

  var errorHandler = function errorHandler(_) {};

  var captureHandler = function captureHandler(handler) {
    return errorHandler = handler;
  };

  var xhr = new XMLHttpRequest();
  xhr.addEventListener("error", function (error) {
    return errorHandler(error);
  });
  xhr.open('GET', url);
  xhr.send();
  return {
    "catch": captureHandler
  };
}

var fetchEnv = function fetchEnv() {
  try {
    var fetch = fetchRequest;
    var hasBeacon = typeof window === 'undefined' ? false : window.navigator && typeof window.navigator.sendBeacon === 'function';
    var userAgent = typeof window === 'undefined' ? 'REACTSSR' : window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
    var performance = typeof window === 'undefined' ? function () {
      return 0;
    } : window.performance;
    return {
      performance: performance,
      beacon: hasBeacon ? window.navigator : undefined,
      fetch: fetch,
      userAgent: userAgent
    };
  } catch (error) {
    return {};
  }
};

function _default(name) {
  var additionalLogData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var batch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var env = arguments.length > 3 ? arguments[3] : undefined;
  return new Logger(name, additionalLogData, batch, env || fetchEnv());
}